import React from "react";
import { Link } from "react-router-dom";
import kakao from "../../../assets/img/carousel/story/kakao.png";
import link from "../../../assets/img/carousel/story/link.png";

import img1 from "../../../assets/img/story/sinanMakerEdu/1.jpg";
import img2 from "../../../assets/img/story/sinanMakerEdu/2.jpg";
import img3 from "../../../assets/img/story/sinanMakerEdu/3.jpg";
import img4 from "../../../assets/img/story/sinanMakerEdu/4.jpg";
import img5 from "../../../assets/img/story/sinanMakerEdu/5.jpg";
import img6 from "../../../assets/img/story/sinanMakerEdu/6.jpg";
import img7 from "../../../assets/img/story/sinanMakerEdu/7.jpg";
import img8 from "../../../assets/img/story/sinanMakerEdu/8.jpg";
import img9 from "../../../assets/img/story/sinanMakerEdu/9.jpg";
import img10 from "../../../assets/img/story/sinanMakerEdu/10.jpg";
import img11 from "../../../assets/img/story/sinanMakerEdu/11.jpg";
import img12 from "../../../assets/img/story/sinanMakerEdu/12.jpg";
import img13 from "../../../assets/img/story/sinanMakerEdu/13.jpg";
import img14 from "../../../assets/img/story/sinanMakerEdu/14.jpg";
import img15 from "../../../assets/img/story/sinanMakerEdu/15.jpg";
import img16 from "../../../assets/img/story/sinanMakerEdu/16.jpg";
import img17 from "../../../assets/img/story/sinanMakerEdu/17.jpg";
import img18 from "../../../assets/img/story/sinanMakerEdu/18.jpg";


function SinanMakerEdu() {
  return (
    <div className="2xl:w-[60%] w-[90%] mx-auto md:mt-10 mt-5 flex flex-col gap-32">
      {/* <h2>Story {id}</h2> */}
      {/* 상단 */}
      <div className="flex flex-col items-center gap-1 md:gap-3">
        <div className="flex text-sm md:text-base lg:text-lg">
          <p>제작</p>
          <p>&nbsp;|&nbsp;</p>
          <p>2022-07</p>
        </div>
        <p className="flex flex-col gap-1 text-lg font-semibold text-center md:text-2xl lg:text-4xl">
          <p>신안군 초등학생들과 함께한</p>
          <p>찾아가는 메이커 교육</p>
        </p>
        {/* <div className="flex gap-3 mt-1 md:mt-3">
          <div className="w-8 p-2 rounded-full md:w-10 bg-boxbg hover:bg-boxbg2">
            <img src={kakao} alt="" className="object-cover" />
          </div>
          <div className="w-8 p-2 rounded-full md:w-10 bg-boxbg hover:bg-boxbg2">
            <img src={link} alt="" className="object-cover" />
          </div>
        </div> */}
      </div>
      {/* 내용 */}
      <div className="flex flex-col items-center gap-5 text-center md:gap-10">
        <div className="flex flex-col gap-1 md:gap-3">
          <div className="flex w-full">
            <img
              className="object-cover w-full aspect-video"
              src={img1}
              alt=""
            />
          </div>
          <div className="flex w-full">
            <img
              className="object-cover w-full aspect-video"
              src={img2}
              alt=""
            />
          </div>
          <div className="flex w-full">
            <img
              className="object-cover w-full aspect-video"
              src={img3}
              alt=""
            />
          </div>
          <p className="text-sm md:text-lg">만들고 싶은 놀이터 생각해보기</p>
        </div>

        <div className="flex flex-col gap-1 md:gap-3">
          <div className="flex w-full">
            <img
              className="object-cover w-full aspect-video"
              src={img4}
              alt=""
            />
          </div>
          <div className="flex w-full">
            <img
              className="object-cover w-full aspect-video"
              src={img5}
              alt=""
            />
          </div>
          <p className="text-sm md:text-lg">만들고 싶은 놀이터 발표</p>
        </div>

        <div className="flex flex-col gap-1 md:gap-3">
          <div className="flex w-full">
            <img
              className="object-cover w-full aspect-video"
              src={img6}
              alt=""
            />
          </div>
          <div className="flex w-full">
            <img
              className="object-cover w-full aspect-video"
              src={img7}
              alt=""
            />
          </div>
          <div className="flex w-full">
            <img
              className="object-cover w-full aspect-video"
              src={img8}
              alt=""
            />
          </div>
          <p className="text-sm md:text-lg">철새놀이터 구상 내용</p>
        </div>

        <div className="flex flex-col gap-1 md:gap-3">
          <div className="flex w-full">
            <img
              className="object-cover w-full aspect-video"
              src={img11}
              alt=""
            />
          </div>
          <div className="flex w-full">
            <img
              className="object-cover w-full aspect-video"
              src={img9}
              alt=""
            />
          </div>
          <div className="flex w-full">
            <img
              className="object-cover w-full aspect-video"
              src={img10}
              alt=""
            />
          </div>
          <p className="text-sm md:text-lg">내가 원하는 뱃지 만들기</p>
        </div>

        <div className="flex flex-col gap-1 md:gap-3">
          <div className="flex w-full">
            <img
              className="object-cover w-full aspect-video"
              src={img13}
              alt=""
            />
          </div>
          <div className="flex w-full">
            <img
              className="object-cover w-full aspect-video"
              src={img14}
              alt=""
            />
          </div>
          <div className="flex w-full">
            <img
              className="object-cover w-full aspect-video"
              src={img15}
              alt=""
            />
          </div>
          <div className="flex w-full">
            <img
              className="object-cover w-full aspect-video"
              src={img16}
              alt=""
            />
          </div>
          <p className="text-sm md:text-lg">철새놀이터 제작</p>
        </div>

        <div className="flex flex-col gap-1 md:gap-3">
          <div className="flex w-full">
            <img
              className="object-cover w-full aspect-video"
              src={img17}
              alt=""
            />
          </div>
          <div className="flex w-full">
            <img
              className="object-cover w-full aspect-video"
              src={img18}
              alt=""
            />
          </div>
          <p className="text-sm md:text-lg">철새놀이터 설치</p>
        </div>

      </div>
      {/* 하단 */}
      <div className="flex flex-col items-center gap-1 md:gap-3">
        {/* <div className="flex gap-3">
          <div className="w-8 p-2 rounded-full md:w-10 bg-boxbg hover:bg-boxbg2">
            <img src={kakao} alt="" className="object-cover" />
          </div>
          <div className="w-8 p-2 rounded-full md:w-10 bg-boxbg hover:bg-boxbg2">
            <img src={link} alt="" className="object-cover" />
          </div>
        </div> */}
        <Link to="/">
          <button className="h-8 mt-3 text-base rounded-full w-28 md:h-10 bg-boxbg hover:bg-boxbg2">
            이전으로
          </button>
        </Link>
      </div>
    </div>
  );
}

export default SinanMakerEdu;
